// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import * as MuiCore from '@material-ui/core';

import * as coreSelectors from 'core/selectors';

import ProfileDropdown from './ProfileDropdown';
import ServiceButtons from './ServiceButtons';
import PageLabel from './PageLabel';
import MenuIcon from '@material-ui/icons/Menu';
import { DesktopVisible } from 'ui/ScreenViewWrappers';

const StyledAppBar = MuiCore.styled(MuiCore.AppBar)(({ theme, agentUserSession=false }) => ({
    position: "sticky",
    top: 0,
    left: 0,
    background: 'none',
    boxShadow: 'none',
    color: 'black',
    backgroundColor: "#fafafa",
    height: agentUserSession ? theme.sizes.agentSessionAppBar :theme.sizes.appBar
}))

const ProfileLabelContainer = MuiCore.styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'

}))

const MenuOpenStyled = MuiCore.styled(MenuIcon)(({ theme }) => ({
    cursor: 'pointer',
    marginRight: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
        display: 'none'
    }
}))

const WarningBar = MuiCore.styled('div')(({ theme }) => ({
    ...theme.typography.body2,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.constrastText,
    fontWeight: 'bold',
    padding: 10,
}));

class Appbar extends Component {
    constructor(props) {
        super(props);
        this.phoneButtonRef = React.createRef();
    }

    render() {
        const { setDrawerOpen, phoneButtonRef, user, agentUserSession } = this.props
        return (
            <StyledAppBar
                agentUserSession={Boolean(agentUserSession)}
            >
                <MuiCore.Hidden xlDown={!Boolean(agentUserSession)}>
                    <WarningBar>
                        WARNING: This is a temporary session for user {user.displayName}.  Close this tab to end the session.
                    </WarningBar>
                </MuiCore.Hidden>
                <MuiCore.Toolbar style={{ justifyContent: 'space-between' }}>
                    <ProfileLabelContainer>
                        <MenuOpenStyled onClick={() => setDrawerOpen(true)} />
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <PageLabel />
                        </div>
                    </ProfileLabelContainer>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <DesktopVisible>
                            <ServiceButtons phoneButtonRef={phoneButtonRef} />
                        </DesktopVisible>
                        <DesktopVisible>
                            <ProfileDropdown setDrawerOpen={setDrawerOpen} />
                        </DesktopVisible>
                    </div>

                </MuiCore.Toolbar>
            </StyledAppBar>

        )
    }
}

const mapStateToProps = (state) => {
    return ({
        user: coreSelectors.getUser(state),
        agentUserSession: coreSelectors.getAgentUserSession(state),
    });
};

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Appbar))